import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchQBRDocuments = async (qbrRtm: string, userRoleID: string) => {
  const url = proxy('/webservice/197/sp/v4/spJBPQBRDocuments/call')

  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const payload = {
    'p.RTM': qbrRtm,
    'p.UserRoleID': userRoleID,
  }

  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const response = await Rest.post({ url, payload, headers })
  if (response && response.Data) {
    return { Data: response.Data }
  }
  return { Data: [] }
}
